import PartPurchaseQualityControlConfirmationDetail from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationDetail';

export default class PartPurchaseQualityControlConfirmationDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partPurchaseQualityControlConfirmationId  = '';
		this.partPurchaseQualityControlConfirmationPartPurchaseQualityControlConfirmationNumber = '';
		this.thickness = '';
		this.width = '';
		this.length = '';
		this.qty = '';
		this.karat = false;
		this.retak = false;
		this.goresan = false;
		this.gelombang = false;
		this.burry = false;
		this.benjolan = false;
		this.otherProblem = false;
		this.ngInformationMultiple = '';
		this.controlCardStatusId  = '';
		this.controlCardStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partPurchaseQualityControlConfirmationId : '0',
			partPurchaseQualityControlConfirmationPartPurchaseQualityControlConfirmationNumber : '0',
			thickness : '0',
			width : '0',
			length : '0',
			qty : '0',
			karat : '0',
			retak : '0',
			goresan : '0',
			gelombang : '0',
			burry : '0',
			benjolan : '0',
			otherProblem : '0',
			ngInformationMultiple : '0',
			controlCardStatusId : '0',
			controlCardStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}